let dt = new Date();

export const beVerbQuestionsPracticeData1 = [
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603177847/be%20verb%20questions%20practice/PNG-images-David-Beckham-7png.png',
    name:'David',
    surname:'Beckham',
    country:'UK',
    profession:'Footballer',
    food:['pasta', 'chilli crab'],
    hobbies:['modelling', 'fencing'],
    age:dt.getFullYear() - 1976,
    pronouns:['his', 'he']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603273235/be%20verb%20questions%20practice/Madonna-Singer-Famous-Celebrity-Celeb-Celebrities-11png.png',
    name:'Madonna',
    surname:'Ciccone',
    country:'USA',
    profession:'Singer',
    food:['avocado roll', 'quinoa'],
    hobbies:['yoga', 'reading'],
    age:dt.getFullYear() - 1958,
    pronouns:['her', 'she']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603177849/be%20verb%20questions%20practice/PNG-images-Vin-Diesel-PNG-Transparent-Image-1png.png',
    name:'Vin',
    surname:'diesel',
    country:'USA',
    profession:'Actor',
    food:['pizza', 'pasta'],
    hobbies:['Cooking', 'playstation', 'snowboarding'],
    age:dt.getFullYear() - 1967,
    pronouns:['his', 'he']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603177852/be%20verb%20questions%20practice/Cristiano-Ronaldo-real-madrid-Football-Player-Soccor-Player-Footballer-PNG-Images--15png.png',
    name:'Cristiano',
    surname:'Ronaldo',
    country:'Postugal',
    profession:'Footballer',
    food:['fish', 'potatoes'],
    hobbies:['cars', 'dogs', 'basball', 'bikes'],
    age:dt.getFullYear() - 1985,
    pronouns:['his', 'he']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603177853/be%20verb%20questions%20practice/PNG-images-FreePNGsCOM-Bill-Gates-PNG-Transparent-Image-1png.png',
    name:'Bill',
    surname:'Gates',
    country:'USA',
    profession:'Businessman',
    food:['hamburgers','cheeseburger'],
    hobbies:['dogs'],
    age:dt.getFullYear() - 1955,
    pronouns:['his', 'he']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603177853/be%20verb%20questions%20practice/PNG-images-FreePNGsCOM-Lionel-Messi-PNG-Transparent-Image-1png.png',
    name:'Leo',
    surname:'Messi',
    country:'Argentina',
    profession:'Footballer',
    food:['Milanesa Napolitana'],
    hobbies:['TV shows', 'playstation', 'sleeping'],
    age:dt.getFullYear() - 1987,
    pronouns:['his', 'he']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603543526/be%20verb%20questions%20practice/PNG-images-PNGs-Micheal-Jackson-Singer--10png.png',
    name:'Michel',
    surname:'Jackson',
    country:'USA',
    profession:'Singer',
    food:['sushi','fish', 'popcorn'],
    hobbies:['dance', 'design', 'games'],
    age:dt.getFullYear() - 1958,
    pronouns:['his', 'he']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603177853/be%20verb%20questions%20practice/Eminem-Slim-Shady-Rapper-Rappers-PNG-Images--5png.png',
    name:'Marshall',
    surname:'Mathers',
    country:'USA',
    profession:'Singer',
    food:['tacos'],
    hobbies:['writing songs', 'basketball'],
    age:dt.getFullYear() - 1972,
    pronouns:['his', 'he']
  },
  {
    image:'https://res.cloudinary.com/nzmai/image/upload/v1603177854/be%20verb%20questions%20practice/PNG-images-FreePNGsCOM-Johnny-Depp-PNG-Transparent-Imagepng.png',
    name:'Johnny',
    surname:'Depp',
    country:'USA',
    profession:'Actor',
    food:['chicken curry', 'noodles'],
    hobbies:['doll collection'],
    age:dt.getFullYear() - 1963,
    pronouns:['his', 'he']
  }
]